import axios from "axios";
import { PROJECTS_URL, projectsUrl } from "../utils";

export const fetchProjects = (professionalId?: string) => {
  return axios.get(projectsUrl(professionalId));
};
